import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .not-active-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 12px;
    border-radius: 8px;
    background-color: white;
    text-decoration: none;
    color: ${colors.BLACK};
    opacity: 1;
    margin-bottom: 16px;
  }

  @media (min-width: ${screen.smMin}) {
    .not-active-card {
      flex-direction: row;
      width: 100%;
      max-width: 770px;
    }
  }

  .outer-container {
    flex-grow: 1;
    position: relative;
    height: 108px;
  }

  .not-available {
    position: absolute;
    top: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 0px 16px 0px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.92);
    letter-spacing: 0.2px;
  }

  @media (min-width: ${screen.smMin}) {
    .not-available {
      flex-grow: 1;
      padding: 28px 0px 32px 0px;
    }
  }

  .image-container {
    overflow: hidden;
    position: relative;
    margin-bottom: 12px;
    padding-top: 60.294%;
    text-align: center;
    border-radius: 4px;
  }

  .not-active-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: auto;
    margin: 0;
    border-radius: 4px;
  }

  @media (min-width: ${screen.smMin}) {
    .image-container {
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      width: 272px;
      height: 164px;
      padding: 0;
      margin-right: 24px;
      margin-bottom: 0;
    }

    .not-active-image {
      position: initial;
      transform: none;
      flex-shrink: 0;
      min-width: 100%;
      min-height: 100%;
    }
  }

  .not-available .text {
    margin-bottom: 18px;
    font-size: 16px;
    font-weight: 300;
    color: ${colors.BLACK};
    letter-spacing: 0.2px;
  }

  @media (min-width: ${screen.smMin}) {
    .not-available .text {
      margin-bottom: 24px;
      font-size: 18px;
    }
  }

  .button {
    width: 138px;
    height: 40px;
    box-sizing: border-box;
    font-size: 16px;
    padding: 9px 0px 11px 0px;
    font-weight: 400;
  }

  .button:focus {
    outline: 0;
  }

  .exit {
    opacity: 0;
    animation: fadeout 0.5s;
  }

  @keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @-moz-keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @-ms-keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @-o-keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;
